import { queryOptions, useQuery } from '@tanstack/react-query';
import { getBrokers } from '@/services/api/brokers';

export const BROKERS_QUERY_KEY = ['brokers'] as const;
// The create-broker mutation invalidates exactly this key after success.
export const BROKERS_LIST_QUERY_KEY = [...BROKERS_QUERY_KEY, 'list'] as const;

export const brokersQueryOptions = () =>
  queryOptions({
    queryKey: BROKERS_LIST_QUERY_KEY,
    queryFn: () => getBrokers(),
  });

export const useBrokers = () => useQuery(brokersQueryOptions());
